import React from 'react'
import { Select } from 'antd'
import { createGlobalStyle, styled } from 'styled-components'
import RedInfoIcon from '../icons/RedInfoIcon'

interface IWizrDropDown {
  placeHolder?: string
  options: any
  onChange?: any
  value?: any
  defaulValue?: any
  className?: any
  style?: any
  mode?: any
  disabled?: boolean
  showSearch?: boolean
  optionFilterProp?: string
  filterOption?: boolean | ((input: string, option?: any) => boolean)
  maxTagCount?: number | 'responsive'
  errorMessage?: string
  showError?: boolean
  required?: boolean
  dropdownRender?: (menu: React.ReactElement) => React.ReactElement
  width?: string | number
  loading?: boolean
  open?: boolean
  onDropdownVisibleChange?: (open: boolean) => void
  tagRender?: any
  labelInValue?: boolean
  dropdownStyle?: React.CSSProperties
  dropdownAlign?: any
}

const GlobalSelectStyles = createGlobalStyle`
  .ant-select-dropdown .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
    background-color: #f0f0f0 !important;
    color: #000 !important;
  }
       .ant-select-multiple .ant-select-selection-wrap{
    align-self: center !important;
  }
`;
const StyledDropDown = styled(Select) <any>`
  .ant-select-selection-item {
    text-align: left;
  }
  width: ${(p) => (p.width ? p.width : '100%')} !important;;
  height: 52px;
  .ant-select-selector {
    border-radius: 16px;
    border-color: ${(p) => (p.showError ? '#ff4d4f' : '#d9d9d9')} !important;
    background: ${(p) => (p.background ?? '#F2F4F9')} !important;
  }

  &::placeholder {
    color: ${(p) => (p.placeholdercolor ? p.placeholdercolor : '#A0A0A0')};
  }

  &:hover .ant-select-selector {
    border-color: ${(p) => (p.showError ? '#ff4d4f' : '#d9d9d9')} !important;
  }

  &.ant-select-focused .ant-select-selector,
  &.ant-select-open .ant-select-selector {
    border-color: ${(p) => (p.showError ? '#ff4d4f' : '#000')} !important;
    box-shadow: ${(p) => (p.showError ? '0 0 0 2px rgba(255, 77, 79, 0.2)' : 'none')} !important;
  }

`

const ErrorText = styled.div`
  color: #ff4d4f;
  font-size: 12px;
  margin-top: 4px;
  font-family: Montserrat;
  display: flex;
  align-items: center;
  gap: 6px;
`
const WizrDropDown = ({
  placeHolder,
  options,
  onChange,
  value,
  defaulValue,
  className,
  style,
  mode,
  disabled,
  showSearch,
  optionFilterProp,
  filterOption,
  maxTagCount,
  errorMessage,
  showError = false,
  required = false,
  dropdownRender,
  width,
  loading,
  open,
  onDropdownVisibleChange,
  tagRender,
  labelInValue,
  dropdownStyle,
  dropdownAlign,
}: IWizrDropDown) => {
  return (
    <>
      <GlobalSelectStyles />
      <StyledDropDown
        loading={loading}
        disabled={disabled}
        mode={mode}
        style={style}
        placeholder={placeHolder}
        options={options}
        onChange={onChange}
        popupMatchSelectWidth={false}
        defaultValue={defaulValue}
        value={value}
        className={className}
        showSearch={showSearch}
        optionFilterProp={optionFilterProp}
        filterOption={filterOption}
        maxTagCount={maxTagCount}
        showError={showError}
        required={required}
        dropdownRender={dropdownRender}
        width={width}
        open={open}
        onDropdownVisibleChange={onDropdownVisibleChange}
        tagRender={tagRender}
        labelInValue={labelInValue}
        dropdownStyle={dropdownStyle}
        dropdownAlign={dropdownAlign}
      />
      {showError && errorMessage && (
        <ErrorText>
          <RedInfoIcon />
          <span>{errorMessage}</span>
        </ErrorText>
      )}
    </>
  )
}

export default WizrDropDown